export const addUrlParamPrefixToKey = (prefix: string, key: string) =>
    `${prefix}${key.charAt(0).toUpperCase()}${key.slice(1)}`

export const stripUrlParamPrefixFromKey = (prefix: string, key: string) => {
    const stripped = key.slice(prefix.length)
    return `${stripped.charAt(0).toLowerCase()}${stripped.slice(1)}`
}

export const addUrlParamPrefix = <P extends object>(prefix: string, params: P): Record<string, string> =>
    Object.fromEntries(
        Object.entries(params)
            .filter(([, value]) => value != null)
            .map(([key, value]) => [addUrlParamPrefixToKey(prefix, key), String(value)])
    )

export const stripUrlParamPrefix = <T>(params: Record<string, string>, prefix: string): Partial<T> =>
    Object.fromEntries(
        Object.entries(params)
            .filter(([key]) => key.startsWith(prefix))
            .map(([key, value]) => [stripUrlParamPrefixFromKey(prefix, key), value])
    ) as Partial<T>
